import React from 'react';
import { IconInfoCircle } from '@tabler/icons-react';
import CategorySelector from '../CategorySelector';

const Step2BasicInfo = ({ 
  formData, 
  register, 
  setValue, 
  errors, 
  saving 
}) => {
  return (
    <div className="mpf-step-content">
      <div className="mpf-step-header">
        <IconInfoCircle size={24} className="text-primary" />
        <h4>Categoria</h4>
        <p className="text-muted">Defina a categoria do agente</p>
      </div>
      
    {/*   <Form.Group className="mb-3">
        <Form.Label>Descrição Resumida *</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          {...register("short_description")}
          placeholder="Descrição breve do agente para listagem..."
          disabled={saving}
          maxLength={FORM_CONSTANTS.MAX_DESCRIPTION_LENGTH}
          isInvalid={!!errors.short_description}
        />
        <Form.Control.Feedback type="invalid">
          {errors.short_description?.message}
        </Form.Control.Feedback>
        <Form.Text className="text-muted">
          Máximo {FORM_CONSTANTS.MAX_DESCRIPTION_LENGTH} caracteres. {(formData.short_description || '').length}/{FORM_CONSTANTS.MAX_DESCRIPTION_LENGTH}
        </Form.Text>
      </Form.Group> */}
      
      <CategorySelector
        value={formData.categories}
        onChange={(value) => setValue("categories", value)}
        error={errors.categories?.message}
        disabled={saving}
      />
    </div>
  );
};

export default Step2BasicInfo;